var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9261 18.8742C25.9144 20.047 25.6088 21.1982 25.0373 22.2224C24.3871 23.4102 23.4103 24.387 22.2224 25.0372C20.8662 25.7655 19.3083 26.0285 17.788 25.7858C16.2678 25.543 14.8693 24.8079 13.8073 23.6933C12.7453 22.5788 12.0786 21.1464 11.9095 19.6162C11.7404 18.086 12.0783 16.5427 12.8713 15.2231C13.6643 13.9036 14.8685 12.8808 16.2991 12.312C17.7296 11.7431 19.3073 11.6596 20.7899 12.0742C22.2725 12.4889 23.578 13.3788 24.5059 14.6072C25.4338 15.8356 25.9327 17.3347 25.9261 18.8742Z",
    stroke: "#FFAC06",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5706 27.5708C27.3888 27.7542 27.1724 27.8998 26.934 27.9992C26.6956 28.0985 26.4399 28.1497 26.1817 28.1497C25.9234 28.1497 25.6677 28.0985 25.4293 27.9992C25.1909 27.8998 24.9746 27.7542 24.7928 27.5708L22.2224 25.0375C23.4103 24.3873 24.3871 23.4105 25.0372 22.2227L27.5706 24.7634C27.7585 24.9457 27.9079 25.1639 28.01 25.405C28.112 25.6461 28.1646 25.9053 28.1646 26.1671C28.1646 26.4289 28.112 26.6881 28.01 26.9292C27.9079 27.1703 27.7585 27.3885 27.5706 27.5708V27.5708Z",
    stroke: "#FFAC06",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4668 18.5631C15.4668 17.7419 15.793 16.9543 16.3737 16.3737C16.9543 15.793 17.7419 15.4668 18.5631 15.4668",
    stroke: "#FFAC06",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch1);
export default __webpack_public_path__ + "static/media/search 1.f74c44faaacb13668506f6b7df512932.svg";
export { ForwardRef as ReactComponent };